

export default function ProjectDetailsDemo({
    src,
    alt="Project Demo",
    isVertical=false,
}){

    const frame = isVertical?
    require("../../../../assets/deviceFrames/frame-ip14.png"):
    require("../../../../assets/deviceFrames/frame-mbp-16-lower-nonotch.png");

    const frameAlt = isVertical?
    "iPhone 14 Device Frame":
    "Macbook Pro 16 Inch with no notch device frame";

    const verticalDivClass = `
        h-[400px]

        sm:h-[500px]

        md:h-[600px]

        lg:h-[700px]

        xl:h-[700px]
    `;

    const horizontalDivClass=`
        w-[325px]

        sm:w-[450px]

        md:w-[550px]

        lg:w-[700px]

        xl:w-[1000px]
    `;

    return(


        <div
            className="
                my-20
                flex
                justify-center
                items-center

            "
        >

            <div
                className={
                    (isVertical?
                    verticalDivClass:
                    horizontalDivClass) +
                    `
                        relative
                    `
                }
            >


                <video 
                    controls={false}
                    autoPlay={true}
                    loop={true}
                    playsInline={true}
                    className={
                        `
                            ${(isVertical?
                                `
                                    h-[96.5%]
                                    inset-1/2
                                    -translate-x-1/2
                                    -translate-y-1/2
                                `
                                :
                                `
                                    w-[80%]
                                    top-[2%]
                                    inset-x-1/2
                                    -translate-x-1/2
                                `
                            )}
                            object-contain
                            absolute
                            -z-10
                            rounded-lg
                        `
                    }
                >
                    <source src={src} type="video/mp4" />
                </video>


                <img
                    src={frame}
                    alt={frameAlt}
                    className={
                        `
                            ${(isVertical?`h-full`:`w-full`)}
                            object-contain
                            h-full
                            w-full
                        `
                    }
                />


            </div>


        </div>
    );

}